import { cloneDeep } from "lodash-es";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

// createPinia
const pinia = createPinia();

// 因为状态管理使用的是setup的方式构建所以我们重写一个$reset并挂载到pinia中
pinia.use(({ store }) => {
	const initialState = cloneDeep(store.$state);

	store.$reset = () => {
		// 直接替换整个 state，保证彻底清空
		store.$patch(cloneDeep(initialState));
	};
});

/**
 * pinia数据持久化
 */
pinia.use(piniaPluginPersistedstate);

export default pinia;
